import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { updateMerchantChannelStatus, addMerchantChannel, updateMerchantChannel, getMerchantChannelDetail, getMerchantChannelList } from '@/services/deliveryChannelManagement';
export default {
  name: 'deliveryChannelManagement',
  components: {},
  i18n: require('./i18n-deliveryChannelManagement'),
  data: function data() {
    return {
      saveLoading: false,
      defaultLangObj: {},
      nameErr: this.$t('deliveryChannelManagement.pleaseEnter') + this.$t('deliveryChannelManagement.name'),
      dataList: [],
      //列表数据
      isTableLoading: false,
      dialogStatus: '',
      //新建/修改状态位
      textMap: {
        //新建/修改title
        update: this.$t('deliveryChannelManagement.edit'),
        create: this.$t('deliveryChannelManagement.add')
      },
      visible: false,
      //新建/修改 显示
      datavalue: {
        //新建/修改 字段
        /* langDataList: [{
              name: '',
              required: true,
              languageType:1,
              languageName: this.$t('deliveryChannelManagement.name')+"（简体）"
            },
            {
              name: '',
              required: false,
              languageType:2,
              languageName: this.$t('deliveryChannelManagement.name')+"（繁体）"
            },
            {
              name: '',
              required: false,
              languageType:3,
              languageName: this.$t('deliveryChannelManagement.name')+"（日文）"
            },
          ], */
        langDataList: [],
        channelType: 0,
        note: ''
      },
      initLangDataList: []
    };
  },
  mounted: function mounted() {
    var self = this;
    self.initData();
    self.getList();
  },
  methods: {
    initData: function initData() {
      //加载列表
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //标题
          nameObj.titleName = self.$t('deliveryChannelManagement.name') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //规格值名称
          nameObj.channelType = 0;
          nameObj.note = '';
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initLangDataList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.langDataList = _.cloneDeep(self.initLangDataList);
    },
    /* 获取列表数据 */getList: function getList() {
      var self = this;
      self.isTableLoading = true;
      getMerchantChannelList().then(function (res) {
        if (res.data.code == 200) {
          self.dataList = res.data.data;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 启用停用按钮 */onUpdateStatus: function onUpdateStatus(id, type, record) {
      var _this = this;
      var statusObj = {
        id: id,
        status: type
      };
      var key = "updateMerchantChannelStatusLoading" + id + type;
      if (record[key]) return;
      record[key] = true;
      updateMerchantChannelStatus(statusObj).then(function (response) {
        if (response.data.code == 200) {
          _this.$message.success(_this.$t('deliveryChannelManagement.updateSuccessfully'));
          _this.getList();
        }
      }).finally(function () {
        record[key] = false;
      });
    },
    //初始化弹窗输入项
    resetDataValue: function resetDataValue() {
      this.datavalue = {
        id: '',
        note: '',
        channelType: 0,
        langDataList: _.cloneDeep(this.initLangDataList)
      };
    },
    /* 编辑按钮 */editBtn: function editBtn(record) {
      var _this2 = this;
      var self = this;
      getMerchantChannelDetail(record.id).then(function (response) {
        if (response.data.code == 200) {
          console.log(response.data.data);
          var langDataList = response.data.data.list;
          self.datavalue.channelType = response.data.data.channelType;
          self.datavalue.note = response.data.data.note;
          self.datavalue.id = record.id;
          var newLangDataList = _.cloneDeep(self.initLangDataList);
          var _iterator2 = _createForOfIteratorHelper(newLangDataList),
            _step2;
          try {
            var _loop = function _loop() {
              var initial = _step2.value;
              var findObj = _.find(langDataList, function (o) {
                return o.langId == initial.langId;
              });
              if (findObj) {
                initial.title = findObj.title;
              }
            };
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          self.datavalue.langDataList = _.cloneDeep(newLangDataList);
          self.dialogStatus = 'update';
          self.visible = true;
          _this2.saveLoading = false;
        }
      });
    },
    /* 添加按钮 */add: function add() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.resetDataValue();
      this.$nextTick(function () {
        _this3.visible = true;
      });
      this.saveLoading = false;
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.resetDataValue();
      this.visible = false;
    },
    /* 确定添加 */save: function save() {
      var _this4 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this4.saveLoading = true;
          addMerchantChannel(_this4.datavalue).then(function (response) {
            if (response.data.code == 200) {
              _this4.$message.success(_this4.$t('public.addSuccessfully'));
              _this4.visible = false;
              _this4.getList();
            }
          }).finally(function () {
            _this4.saveLoading = false;
          });
        }
      });
    },
    /* 确定更新 */update: function update() {
      var _this5 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this5.saveLoading = true;
          updateMerchantChannel(_this5.datavalue).then(function (response) {
            if (response.data.code == 200) {
              _this5.$message.success(_this5.$t('public.updateSuccessfully'));
              _this5.visible = false;
              _this5.getList();
            }
            _this5.saveLoading = false;
          }).finally(function () {
            _this5.saveLoading = false;
          });
        }
      });
    },
    goProductList: function goProductList(id) {
      this.$router.push({
        path: '/productmanager/productList',
        query: {
          productChannelid: id
        }
      });
    }
  }
};